(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/popupbox/assets/javascripts/helpers/handlebarshelpers.js') >= 0) return;  svs.modules.push('/components/components/popupbox/assets/javascripts/helpers/handlebarshelpers.js'); (function() {
  'use strict';

  if (typeof exports === 'object') {
    registerHelpers(require('hbs'));
  } else {
    registerHelpers(Handlebars);
  }

  function registerHelpers(hbs) {
    hbs.registerHelper('getContext', function(model) {
      return (model instanceof Array && !model.length && {}) || model || {};
    });

    hbs.registerHelper('shouldShowBoxContents', function(
      dataError,
      partialError,
      suppressErrors,
      options
    ) {
      if (dataError && !partialError && !suppressErrors) {
        return options.inverse(this);
      }
      return options.fn(this);

    });

    hbs.registerHelper('removePathBase', function(url) {
      var index;
      if (url) {
        index = url.indexOf('/');
        if (index === 0) {
          index = url.indexOf('/', 1);
          if (!~index) {
            return '/';
          }
        }
        return url.substring(index);
      }
      return url;
    });
  }
})();

 })(window);